import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../i18n/translations';
import { FileDown } from 'lucide-react';

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-[#f4f6fb] border-t border-slate-100 mt-auto" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <img src="/logo-mp.png" alt="Ministarstvo privrede" className="h-14 w-auto mb-4" />
            <p className="text-sm text-slate-500 leading-relaxed max-w-xs">
              E-Turizam – Turistički vodič i registar turističke ponude Srednjobosanskog kantona / Kantona Središnja Bosna
            </p>
            <a href="/E-Turizam-Dokumentacija.pdf" target="_blank" rel="noreferrer" data-testid="footer-docs-download"
              className="inline-flex items-center gap-2 mt-5 px-4 py-2 rounded-md bg-[#001752] text-white text-sm font-medium hover:bg-[#0a2a7a] transition-colors duration-200">
              <FileDown className="h-4 w-4" /> {t('docsDownload')}
            </a>
          </div>
          <div className="md:text-right">
            <h4 className="font-semibold text-[#001752] text-lg mb-4">{t('footerAddress')}</h4>
            <div className="space-y-1.5 text-sm text-slate-500">
              <p>Bosna i Hercegovina</p>
              <p>Federacija Bosne i Hercegovine</p>
              <p>Srednjobosanski kanton / Kanton Središnja Bosna</p>
              <p>ul. Prnjavor 16, 72270 Travnik</p>
              <p>Tel: +387 (0)30 511 217</p>
            </div>
          </div>
          <div className="md:text-right">
            <h4 className="font-semibold text-[#001752] text-lg mb-4">{t('footerLinks')}</h4>
            <div className="space-y-1.5 text-sm">
              <Link to="/obavijesti" className="block text-slate-500 hover:text-[#001752] transition-colors duration-200">{t('notices')}</Link>
              <Link to="/ponuda" className="block text-slate-500 hover:text-[#001752] transition-colors duration-200">{t('offer')}</Link>
              <Link to="/kalendar" className="block text-slate-500 hover:text-[#001752] transition-colors duration-200">{t('calendar')}</Link>
              <Link to="/o-nama" className="block text-slate-500 hover:text-[#001752] transition-colors duration-200">{t('about')}</Link>
              <Link to="/kontakt" className="block text-slate-500 hover:text-[#001752] transition-colors duration-200">{t('contactUs')}</Link>
            </div>
          </div>
        </div>
        <div className="border-t border-slate-200 mt-10 pt-6">
          <p className="text-xs text-slate-400 leading-relaxed" data-testid="footer-legal">
            Demo stranica izrađena u skladu s tenderskom dokumentacijom Ministarstva privrede Srednjobosanskog kantona / Ministarstva gospodarstva Kantona Središnja Bosna
            (tehnička specifikacija IS „E-Turizam", tačka 9.2 – Testne funkcionalnosti). Aplikaciju je izradio ponuditelj <b className="text-slate-500">VTZ d.o.o. Mostar</b> i
            sastavni je dio tenderske dokumentacije i ponude. Prikazani sadržaji i podaci su demonstracionog karaktera i ne predstavljaju službene informacije.
          </p>
          <div className="flex flex-col md:flex-row justify-between gap-2 mt-4">
            <p className="text-xs text-slate-400 italic">Copyright@ 2025 Ministarstvo privrede / Ministarstvo gospodarstva SBK-KSB • Izrada: VTZ d.o.o. Mostar</p>
            <p className="text-xs text-slate-400 italic">{t('allRights')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
